import { TagCategory } from "../../model/tag/TagCategory";
import { api } from "../api";
import { parseTagCategory } from "../../parsers/tags/parseTagCategory";

export const putTagCategory = async (id: string, title: string): Promise<TagCategory> => {
  const response = await api.services.tagCategories.updateTagCategory(id, { name: title });
  return parseTagCategory(response.data);
};
